import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyleActivity = makeStyles((theme) => createStyles({
  root: {
    backgroundImage: `linear-gradient(180deg, hsla(183, 92%, 35%, 0.9) 0%, #00abae 100%);`,
    height: "100%",
    cursor: "pointer",
    border: '2px inset transparent',
    overflow: "hidden", // Masquer le contenu hors limites
    position: "relative",
    borderRadius: 10, // Arrondir les bords
    // clipPath: `polygon(
    //   0 10px,  /* Coin supérieur gauche */
    //   10px 0,  /* Coin supérieur gauche */
    //   calc(100% - 10px) 0,  /* Coin supérieur droit */
    //   100% 10px,  /* Coin supérieur droit */
    //   100% calc(100% - 10px),  /* Coin inférieur droit */
    //   calc(100% - 10px) 100%,  /* Coin inférieur droit */
    //   10px 100%,  /* Coin inférieur gauche */
    //   0 calc(100% - 10px)  /* Coin inférieur gauche */
    // )`,

  },
  rootHover: {
    "--mouse-x": "0px",
    "--mouse-y": "0px",
    "&:hover": {
      background: 'radial-gradient(circle at var(--mouse-x) var(--mouse-y), hsla(181, 100%, 34%, 0.8) 0%, hsl(181, 100%, 34%) 90%, hsl(181, 52%, 39%) 100%)',
      transition: "background 0.3s linear",
      border: '2px outset hsla(183, 92%, 65%, 1)',
      boxShadow: '6px 6px 11px -3px rgba(0,0,0,0.48)',
      "& $iconCustom": {
        transform: "scale(1.9) translate(10px, -10px)",
        position: "absolute",
      },
    },
  },
  rootSousActivite: {
    backgroundImage: `linear-gradient(180deg, #3E739D 0%, #2a5d83 100%);`,
    height: "100%",
    borderRadius: 10,
    border: '2px inset transparent',
    overflow: "hidden",
    position: "relative",
  },
  rootSousActiviteHover: {
    "--mouse-x": "0px",
    "--mouse-y": "0px",
    "&:hover": {
      background: 'radial-gradient(circle at var(--mouse-x) var(--mouse-y), hsla(205, 90.5%, 33.9%, 0.85) 0%,hsl(205, 90.5%, 33.9%) 90%, hsl(205, 95.5%, 33.9%) 100%)',
      transition: "background 0.3s linear",
      border: '2px outset hsla(205.7, 92%, 65%, 1)',
      boxShadow: '6px 6px 11px -3px rgba(0,0,0,1.48)',
      "& $iconCustom": {
        transform: "scale(1.9) translate(10px, -10px)",
        position: "absolute",
      },
    },
  },
  presentationText: {
    color: "#FFFFFF",
  },
  bouton: {
    fontSize: 11,
    backgroundColor: "#3378af",
    color: "#FFF",
  },
  filtre: {
    width: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  groupeBouton: {
    marginBlock: "0.5vw",
    width: "100%",
  },
  titreCard: {
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  iconCustom: {
    position: "absolute",
    bottom: "-20px",
    left: "20px",
    // transform: "translateY(-50%)",
    zIndex: 0,
    fontSize: "60px",
    color: "rgba(255, 255, 255, 0.15)",
    transition: "transform 0.5s cubic-bezier(0.77, 0, 0.175, 1)", // Utiliser une animation transitoire
  },
  cardHead: {
    background: "#015384",
    color: "#FFF",
  },
  paperClass: {
    padding: theme.spacing(4),
  },
  searchWrapper: {
    boxShadow: "0px -1px 7px rgba(0, 0, 0, 0.2)", /* Ombre portée inférieure */
    zIndex: "100",
    position: "fixed", /* Positionnement absolu relatif à son parent le plus proche non statique */
    top: "94px", /* Hauteur de la navbar */
    width: "auto",
    left: 0,
    right: 0,
    paddingRight: "15px", /* Compensation pour empêcher le chevauchement horizontal sur la scrollbar */
    backgroundColor: "rgba(231, 235, 243, 0.4)",
    backdropFilter: "blur(22px) saturate(143%)",
  },
  searchWrapperSmall: {
    width: "calc(100% - 220px)",
    left: 'auto',
    right: 0,
  },
}));